import type { MonitoringStatusResponse } from '@/domains/landing-page/types/monitoring-status.types';
import { request } from '@/shared/utils/request';

export const monitoringStatusApi = {
  // GET /api/dsh/monitoring-status/{report_code_id} -> { report_code_id, patients[] }
  getMonitoringStatus: async (reportCode: string): Promise<MonitoringStatusResponse> => {
    return request.get<MonitoringStatusResponse>(`/monitoring-status/${reportCode}`);
  },
};
